import { moneyFromMajor } from '../../money/money.js';
import { defineVertical } from '../vertical.js';

const rub = (amount: number) => moneyFromMajor(amount, 'RUB');

export const beautySalon = defineVertical({
  id: 'beauty_salon',
  presentation: { icon: 'sparkles' },
  vocabulary: { staff: 'master', resource: 'workplace', client: 'client' },
  resourceTypes: [
    { id: 'hair_chair', term: 'hair_chair' },
    { id: 'nail_desk', term: 'nail_desk' },
    { id: 'pedicure_chair', term: 'pedicure_chair' },
  ],
  serviceCategories: ['hair', 'nails', 'brows'],
  serviceTemplates: [
    {
      key: 'women_haircut',
      categoryKey: 'hair',
      durationMinutes: 60,
      bufferBeforeMinutes: 0,
      bufferAfterMinutes: 10,
      suggestedPrice: rub(2500),
      resourceTypeId: 'hair_chair',
    },
    {
      key: 'men_haircut',
      categoryKey: 'hair',
      durationMinutes: 45,
      bufferBeforeMinutes: 0,
      bufferAfterMinutes: 10,
      suggestedPrice: rub(1500),
      resourceTypeId: 'hair_chair',
    },
    {
      key: 'hair_coloring',
      categoryKey: 'hair',
      durationMinutes: 120,
      bufferBeforeMinutes: 10,
      bufferAfterMinutes: 15,
      suggestedPrice: rub(5500),
      resourceTypeId: 'hair_chair',
    },
    {
      key: 'blowout',
      categoryKey: 'hair',
      durationMinutes: 45,
      bufferBeforeMinutes: 0,
      bufferAfterMinutes: 5,
      suggestedPrice: rub(1800),
      resourceTypeId: 'hair_chair',
    },
    {
      key: 'gel_manicure',
      categoryKey: 'nails',
      durationMinutes: 90,
      bufferBeforeMinutes: 5,
      bufferAfterMinutes: 10,
      suggestedPrice: rub(2200),
      resourceTypeId: 'nail_desk',
    },
    {
      key: 'classic_manicure',
      categoryKey: 'nails',
      durationMinutes: 60,
      bufferBeforeMinutes: 5,
      bufferAfterMinutes: 10,
      suggestedPrice: rub(1400),
      resourceTypeId: 'nail_desk',
    },
    {
      key: 'pedicure',
      categoryKey: 'nails',
      durationMinutes: 90,
      bufferBeforeMinutes: 5,
      bufferAfterMinutes: 15,
      suggestedPrice: rub(2800),
      resourceTypeId: 'pedicure_chair',
    },
    {
      key: 'brow_shaping',
      categoryKey: 'brows',
      durationMinutes: 30,
      bufferBeforeMinutes: 0,
      bufferAfterMinutes: 5,
      suggestedPrice: rub(900),
      resourceTypeId: null,
    },
    {
      key: 'brow_tint',
      categoryKey: 'brows',
      durationMinutes: 30,
      bufferBeforeMinutes: 0,
      bufferAfterMinutes: 5,
      suggestedPrice: rub(700),
      resourceTypeId: null,
    },
  ],
  rules: {
    slotStepMinutes: 15,
    minLeadMinutes: 60,
    horizonDays: 60,
    maxServicesPerBooking: 4,
    staffAssignment: 'balanced',
    calendarPolicy: {
      closeOnPublicHolidays: false,
      closeOnNonWorkingDays: false,
      preHolidayShorteningMinutes: 0,
    },
    prepayment: { depositPercent: 0, holdMinutes: 15 },
    repeatVisit: { suggestAfterDays: 35 },
    clientChanges: { cutoffMinutes: 120 },
    waitlist: { offerHoldMinutes: 20 },
  },
});
